import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import * as common from './util/common';
import { Notify, Toast, Picker, Popup, Icon } from 'vant';

Vue.config.productionTip = false
Vue.prototype.$common = common;

// Vue.use(ElementUI)
Vue.use(Notify)
Vue.use(Toast)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Icon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
